import { useState } from "react";

import { type EmailCardData } from "@/lib/emails";

import { EmailCard } from "./EmailCard";

interface FyiSectionProps {
  emails: EmailCardData[];
  onSelect?: (id: string) => void;
}

export function FyiSection({ emails, onSelect }: FyiSectionProps) {
  const [expanded, setExpanded] = useState(false);
  const count = emails.length;

  return (
    <section
      className="mt-6 rounded-lg border border-op-border bg-op-surface"
      data-testid="fyi-section"
      data-expanded={expanded}
    >
      <button
        type="button"
        aria-expanded={expanded}
        aria-controls="fyi-list"
        onClick={() => setExpanded((v) => !v)}
        className="flex w-full items-center justify-between gap-2 px-4 py-3 text-left text-sm text-op-secondary hover:bg-op-elevated focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-op-accent"
      >
        <span className="flex items-center gap-2">
          <span
            aria-hidden
            className="h-2 w-2 rounded-full"
            style={{ backgroundColor: "var(--op-text-muted)" }}
          />
          <span className="uppercase tracking-wider text-op-muted">
            Auto-Handled / FYI
          </span>
          <span className="rounded-full bg-op-elevated px-2 py-0.5 text-xs text-op-secondary">
            {count}
          </span>
        </span>
        <span aria-hidden className="text-op-muted">
          {expanded ? "Hide" : "Show"}
        </span>
      </button>
      {expanded ? (
        <div
          id="fyi-list"
          className="grid grid-cols-1 gap-2 border-t border-op-border p-4 md:grid-cols-2 lg:grid-cols-3"
        >
          {count === 0 ? (
            <p
              className="rounded-lg border border-dashed border-op-border px-3 py-6 text-center text-xs text-op-muted md:col-span-2 lg:col-span-3"
              data-testid="fyi-empty"
            >
              No FYI items in the last 7 days.
            </p>
          ) : (
            emails.map((email) => (
              <EmailCard key={email.id} email={email} onSelect={onSelect} />
            ))
          )}
        </div>
      ) : null}
    </section>
  );
}
